import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import { Avatar, Link as MuiLink, Button } from "@mui/material";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import { useState, useEffect } from "react";
import HelpInstructions from "../ingredients/HelpInstructions";
import { getInitials } from "../../helpers/userUtils";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";
import secureLocalStorage from "react-secure-storage";
import Cookies from "js-cookie";
import { hasAdminOrEditorAccess } from "../../helpers/roles";
import { useAnalyticsEventTracker } from "./useAnalyticsEventTracker";
import { HashLink } from "react-router-hash-link";

export default function Navbar() {
  const navigate = useNavigate();
  const eventTracker = useAnalyticsEventTracker();
  const [anchorEl, setAnchorEl] = useState(null);
  const [isInstructionsOpen, setIsInstructionsOpen] = useState(false);
  const { t } = useTranslation();

  const storedUser = secureLocalStorage.getItem("userInfo");
  const existingUser = Cookies.get("exist");

  const user = JSON.parse(storedUser);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLogout = () => {
    const lang = secureLocalStorage.getItem("language");

    sessionStorage.removeItem("authToken");
    secureLocalStorage.clear();

    setAnchorEl(null);
    secureLocalStorage.setItem("language", lang);
    eventTracker("logout", {
      user_id: user.userId,
    });
    navigate("/signin");
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenInstructions = () => {
    setIsInstructionsOpen(true);
    eventTracker("help_instruction_view", {
      user_id: user.userId,
    });
  };

  const handleCloseInstructions = () => {
    setIsInstructionsOpen(false);
  };

  const handleRedirectAdminDashboard = () => {
    navigate("/admin-dashboard");
    handleClose();
  };

  useEffect(() => {
    if (!existingUser) {
      setIsInstructionsOpen(true);
      Cookies.set("exist", true);
    }
  }, []);

  return (
    <Box sx={{ flexGrow: 1, marginBottom: "70px" }}>
      <AppBar position="fixed" color="success" variant="">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            <MuiLink
              component={RouterLink}
              to="/dashboard"
              color="inherit"
              underline="none"
            >
              <img
                src="assets/logos/RitaWhite-2023Logo.png"
                alt="logo"
                style={{ width: "150px", height: "50px" }}
              />
            </MuiLink>
          </Typography>

          <MuiLink
            component={RouterLink}
            to="/"
            color="inherit"
            underline="none"
            sx={{ marginRight: 4 }}
          >
            {t("navigation.list.home")}
          </MuiLink>

          <HashLink
            component={RouterLink}
            smooth
            to="/#platform-info"
            style={{
              marginRight: "40px",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            {t("navigation.list.platforminia")}
          </HashLink>

          <MuiLink
            component={RouterLink}
            to="/contact"
            color="inherit"
            underline="none"
            sx={{ marginRight: 4 }}
          >
            {t("navigation.list.contact")}
          </MuiLink>

          <LanguageSwitcher />
          <Button
            color="inherit"
            onClick={handleOpenInstructions}
            sx={{ marginRight: 2 }}
          >
            {t("navigation.list.help")}
          </Button>

          <div>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <Avatar>{getInitials(user?.firstName, user?.lastName)}</Avatar>
            </IconButton>

            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              {hasAdminOrEditorAccess(user) && (
                <MenuItem onClick={handleRedirectAdminDashboard}>
                  {" "}
                  {t("navigation.list.admin-dashboard")}
                </MenuItem>
              )}

              <MenuItem onClick={handleLogout}>
                {" "}
                {t("navigation.list.logout")}
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>

      <HelpInstructions
        open={isInstructionsOpen}
        onClose={handleCloseInstructions}
      />
    </Box>
  );
}
